import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuperscreeninline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				strokeLinejoin: "round",
				d: "M18 16h-2L7 3h50l-9 13h-2M24 20v-9M40 20v-9"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 28,
				height: 41,
				x: 18,
				y: 20,
				strokeLinejoin: "round",
				rx: 2
			}),
			/* @__PURE__ */ _jsx("path", { d: "M18 24.6h28m-24-14h4m12 0h4" })
		]
	})
});
export default SvgSuperscreeninline;
